import { GetterTree } from 'vuex';
import { WalletInfoInterface } from './wallet.type';

export const getters: GetterTree<WalletInfoInterface, any> = {
  walletInfo: (state) => state.walletInfo,
};
